import { Component } from '@angular/core';
import { ProductoList } from '@app/entidades/operacion.model';
import { StorageService } from '@app/servicios/storage/storage.service';

@Component({
  selector: 'app-carrito',
  templateUrl: './carrito.component.html',
  styleUrls: ['./carrito.component.scss'],
})
export class CarritoComponent {
  public cart = false;

  public lista: ProductoList[] = [];
  public total = 0;

  constructor(private storageService: StorageService) {}

  ngOnInit() {
    this.consultarProductos();
  }

  consultarProductos() {
    this.lista = this.storageService.getItem('lp') || [];
    this.calcularTotal();
  }

  calcularTotal() {
    if (!this.lista || this.lista.length === 0) {
      this.total = 0;
      return;
    }

    let total = 0;
    this.lista.forEach((producto) => {
      const cant = +(producto.cantidad ?? 0);
      const precioPublico = +(producto.precio?.publico ?? 0);
      total += precioPublico * cant;
    });

    this.total = total;
  }

  sumar(id: string) {
    if (!this.lista) return;

    this.lista.forEach((producto) => {
      if (producto.id === id) {
        const maxStock = +(producto.stock ?? 99999);
        if (producto.cantidad < maxStock) {
          producto.cantidad++;
        }
      }
    });
    this.storageService.setItem('lp', this.lista);
    this.calcularTotal();
  }

  restar(id: string) {
    if (!this.lista) return;

    this.lista.forEach((producto) => {
      if (producto.id === id) {
        if (producto.cantidad > 1) {
          producto.cantidad--;
        }
      }
    });
    this.storageService.setItem('lp', this.lista);
    this.calcularTotal();
  }

  public eliminar(id: any) {
    if (!this.lista) return;

    this.lista = this.lista.filter((p) => p.id !== id);
    this.calcularTotal();
    this.storageService.setItem('lp', this.lista);
  }
}
